export default __webpack_public_path__ + "static/19-567312f6dd10e87b9e5efe300fb6b937.jpg";